import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
    import * as z from "zod";
    import { useRoute, useRouter } from 'vue-router';
    import { BACKEND_SERVER } from '../module/common/env';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterUser',
  setup(__props, { expose: __expose }) {
  __expose();

    let username = ref("")
    let email = ref("")
    let password = ref("")
    let repeat_password = ref("")

    let username_error = ref("")
    let email_error = ref("")
    let password_error = ref("")
    let repeat_password_error = ref("")

    let form_errors = ref("")

    const route = useRoute()
    const router = useRouter()

    function cleanErrors (error: z.ZodError, field: string) {
        const loc_errors = error.issues
            .filter((tmp_issue) => {
                return tmp_issue.path.includes(field)
            })
            .map((tmp_issue) => {
                return tmp_issue.message
            })
        
        if (loc_errors.length > 0) {
            return loc_errors.join(', ')
        } else {
            return ""
        }
    }

    let loading = ref(true)
    let token_error = ref("")
    let user_id = ref<number | null>(null)

    onMounted(async () => {
        loading.value = true
        token_error.value = ""

        const newUserToken = route.params.new_user_token

        if (!newUserToken) {
            token_error.value = "Missing token"
            loading.value = false
            return
        }

        try {
            const response = await fetch(
                BACKEND_SERVER + "/users/check-token",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ token: newUserToken })
                }
            )

            if (!response.ok) {
                token_error.value = "Invalid or expired token"
                loading.value = false
                return
            }

            const data = await response.json()

            if (data.user_id) {
                user_id.value = data.user_id
            } else {
                token_error.value = "Invalid user"
            }

        } catch (err) {
            token_error.value = "Server error while validating token"
        } finally {
            loading.value = false
        }
    })

    function register_user(username: string, email: string, password: string, repeat_password: string) {
        form_errors.value = ""
        username_error.value = ""
        email_error.value = ""
        password_error.value = ""
        repeat_password_error.value = ""

        let validation_schema: z.ZodObject
        if ((user_id.value ?? -1) > 0) {
            validation_schema = z.object({
                password: z.string().min(1, "Password is required"),
                repeat_password: z.string(),
            })
            .refine((data) => data.password === data.repeat_password, {
                message: "Passwords do not match",
                path: ["repeat_password"],
            });
        } else {
            validation_schema = z.object({
                username: z.string().min(1, "Username is required"),
                email: z.email().min(1, "Email is required"),
                password: z.string().min(1, "Password is required"),
                repeat_password: z.string(),
            })
            .refine((data) => data.password === data.repeat_password, {
                message: "Passwords do not match",
                path: ["repeat_password"],
            });
        }        

        const result = validation_schema.safeParse({ username, email, password, repeat_password});
        if (!result.success) {
            username_error.value = cleanErrors(result.error, 'username')
            email_error.value = cleanErrors(result.error, 'email')
            password_error.value = cleanErrors(result.error, 'password')
            repeat_password_error.value = cleanErrors(result.error, 'repeat_password')
            return
        }

        const user = result.data

        const newUserToken = route.params.new_user_token;

        if (!newUserToken) {
            form_errors.value = "Missing 'new_user_token' route parameter";
            return;
        }

        const payload = {
            username: user.username,
            email: user.email,
            password: user.password,
            new_user_token: newUserToken
        };

        fetch(BACKEND_SERVER + "/register", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
            })
            .then(response => {
                if (!response.ok) { 
                    form_errors.value = "Unable to register user!";
                }
                return response.text();
            })
            .then(data => {
                if (form_errors.value === "") {
                    router.push('/login')
                }
            })
            .catch(error => {

                form_errors.value = error;
            });
    }


const __returned__ = { get username() { return username }, set username(v) { username = v }, get email() { return email }, set email(v) { email = v }, get password() { return password }, set password(v) { password = v }, get repeat_password() { return repeat_password }, set repeat_password(v) { repeat_password = v }, get username_error() { return username_error }, set username_error(v) { username_error = v }, get email_error() { return email_error }, set email_error(v) { email_error = v }, get password_error() { return password_error }, set password_error(v) { password_error = v }, get repeat_password_error() { return repeat_password_error }, set repeat_password_error(v) { repeat_password_error = v }, get form_errors() { return form_errors }, set form_errors(v) { form_errors = v }, route, router, cleanErrors, get loading() { return loading }, set loading(v) { loading = v }, get token_error() { return token_error }, set token_error(v) { token_error = v }, get user_id() { return user_id }, set user_id(v) { user_id = v }, register_user }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})